import common from './common';

export const environment = {
  ...common,
  urlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/api-auth',
  isoUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/iso27001/',
  catUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/catffiec/',
  swiftUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/swift/',
  sycUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/syc/',
  ethUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/eth/',
  prvUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/prv/',
  pypUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/pyp/',
  cdpUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/cdp/',
  nistUrlEndPoint: 'https://dev.ciberseguridad.bci.sermaluc.com/nist/',
  production: false,
};
